import React, { PureComponent } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FormGroup, Label, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { isURL } from 'validator';
import { string, func, node, object } from 'prop-types';
import WithPlaceholder from '../../hoc/WithPlaceholder';
import { ThemedFMessage } from '../../hoc/IntlComponents';

class DomainUrl extends PureComponent {
  static propTypes = {
    url: string.isRequired,
    error: node,
    onUrlChange: func,
    message: object,
  };

  static defaultProps = {
    message: {},
  };

  handleChange = ({ target }) => {
    this.props.onUrlChange(target.value);
  };

  render() {
    const { url, message, className, isEdit, theme } = this.props;

    return (
      <FormGroup
        className={cn(className, {
          'has-error': !message.status && message.status !== undefined,
          'has-success': message.status,
        })}
      >
        <Label className="label-required">
          <ThemedFMessage id="domain.form.url.label" />
        </Label>

        {/* {theme === 4 ? (
          <div className="input-wrapper mr-3">
            <WithPlaceholder
              name="url"
              value={url}
              onChange={this.handleChange}
              placeholder="domain.form.url.placeholder"
              autoComplete="off"
              readOnly={isEdit}
            />
            {message.text && <small className="form-text">{message.text}</small>}{' '}
          </div>
        ) : ( */}
          <WithPlaceholder
            name="url"
            value={url}
            onChange={this.handleChange}
            placeholder="domain.form.url.placeholder"
            autoComplete="off"
            readOnly={isEdit}
          />
        {/* )} */}
        {message.text && <small className="form-text">{message.text}</small>}
      </FormGroup>
    );
  }
}

export default DomainUrl;
